'use strict';
const Hammer = require('hammerjs');
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');
const { configuratorCtas } = require('../configuratorCtas');

const BREAKPOINTS = {
    sm: 441,
    md: 1024,
    lg: 1440
}

/**
 * Module: configuratorFooter
 * Handles the footer area of the vehicle configurator UX.
 *
 * Example:-
 * - Adjust DOM for footer and mobile layout on load
 * - Load and display dealer lists based on user location and handle confirmation
 * - Provide mobile drawer (footer accordion) gesture handlers
 *
 * Exposes lifecycle methods used by the configurator page to wire these behaviors.
 */
const configuratorFooter = {
    initLocationAndDealersEvent: function () {
        $('body').on('stores:getDealers', function (el, data) {
            var userLocationCookieID = (data && data.cookieID) ? data.cookieID : 'userloc';
            var $configuratorLocationDealers = $('#configurator-location-dealers');
            var $configuratorLocationDealersTestDrive = $('#configurator-location-dealers-test-drive');
            var $summaryFinanceDealersLocation = $('#summary-location-dealers-for-finance');
            // In-flyout "Change Honda Centre" picker. Kept on the same fan-out as the legacy
            // containers so a single postcode change refreshes every dealer list visible to
            // the user (the standalone footer modal, the test-drive sidebar, the legacy finance
            // popup, and now the in-flyout picker).
            var $flyoutFinanceLocationDealers = $('#flyout-finance-location-dealers');
            var $configuratorLocationConfirm = $('#configurator-location-confirm');
            var $configuratorGoogleAutocomplete = $('#configurator-google-autocomplete');
            $configuratorLocationConfirm.attr('disabled', 'disabled');
            $configuratorLocationDealers.html(`<div class="skeleton skeleton-lg"></div>
                    <div class="configurator-location__dealers__list" >
                        <div class="skeleton skeleton-sm mb-2"></div>
                        <div class="skeleton skeleton-md mb-2"></div>
                        <hr class="m-2" />
                        <div class="skeleton skeleton-sm mb-2"></div>
                        <div class="skeleton skeleton-md mb-2"></div>
                        <hr class="m-2" />
                        <div class="skeleton skeleton-sm mb-2"></div>
                        <div class="skeleton skeleton-md mb-2"></div>
                    </div>`);

            $.ajax({
                url: $configuratorLocationDealers.data('action'),
                type: 'get',
                dataType: 'json',
                data: {
                    userLocationCookieID: userLocationCookieID,
                    requestFrom: 'Configurator Footer Modal'
                },
                success: function (data) {
                    const dealersListHtml = data.innerHTML || 'Unable to get Dealers List';
                    const containers = [
                        $configuratorLocationDealers,
                        $configuratorLocationDealersTestDrive,
                        $summaryFinanceDealersLocation,
                        $flyoutFinanceLocationDealers
                    ];

                    // Add index suffix to avoid duplicate unique element IDs.
                    containers.forEach(function (container, index) {
                        container.html(dealersListHtml.replace(/\s(id|for)="([^"]*)"/g, (match, attr, value) => {
                            return ` ${attr}="${value}-${index}"`;
                        }));

                        container.trigger('stores:changeDealers');
                    });

                    var userLocation = JSON.parse(frontendUtils.getCookie(userLocationCookieID) || 'null');
                    $configuratorGoogleAutocomplete.val(userLocation.summary);
                    var $userLocationInputInvalid = $('.configurator-location--invalid-error-msg');
                    var $locationApiError = $('#configurator-location-error-msg');
                    $userLocationInputInvalid.removeClass('d-flex');
                    $locationApiError.removeClass('d-flex');
                    if (data.stores && data.stores.length) {
                        $configuratorLocationConfirm.removeAttr('disabled');
                    }
                }
            });
        });

        $('body').on('configurator:footer:location:confirmed', function () {
            // Re-enable the close affordances on the configurator flyout that were locked open when the
            // first-visit Change-Honda-Centre flow forced the user to pick a location before continuing.
            $('.configurator-modal').find('.close, .btn-back').show();
        });
    },
    footerOnProductAddToCart: function () {
        var $orderNowCtas = configuratorCtas.$orderNow();

        $('body').on('product:beforeAddToCart', function () {
            $orderNowCtas.addClass('disabled');
            $orderNowCtas.prop('disabled', true);
        });

        $('body').on('product:afterAddToCart', function () {
            var orderable = configuratorCtas.isProductOrderable();

            $orderNowCtas.toggleClass('disabled', !orderable);
            $orderNowCtas.prop('disabled', !orderable);

            configuratorCtas.reapplyOrderNowDisabled();
        });
    },
    mobileFooterDrawerEvents: function () {
        // mobile gesutee for drawer open and close
        var configuratorFooterAccordion = document.querySelector('#configurator-footer-accordion-p');
        configuratorFooterAccordion.addEventListener('touchmove', function (e) {
            e.stopPropagation();
            e.preventDefault();
        }, { passive: false });
        var HammerFooterAccordion = new Hammer(configuratorFooterAccordion);
        HammerFooterAccordion.get('pan').set({
            direction: Hammer.DIRECTION_VERTICAL,
            threshold: 2
        });
        var $ConfiguratorFooterAccordion = $('#configurator-footer-accordion');
        HammerFooterAccordion.on('panup', function (e) {
            $ConfiguratorFooterAccordion.collapse('show');
        });
        HammerFooterAccordion.on('pandown', function (e) {
            $ConfiguratorFooterAccordion.collapse('hide');
        });
    },
    setupPageListeners: function () {
        /*Events that shoud load on page load*/
        this.initLocationAndDealersEvent();
        this.mobileFooterDrawerEvents();
        this.footerOnProductAddToCart();
    },
    initConfiguratorEvents: function () {
        /* events that be triggred based on customer interactions example cta clicks.*/
    },
    init: function () {
        this.initConfiguratorEvents();
        this.setupPageListeners();
    },
}

module.exports = configuratorFooter;
